module.exports = __webpack_public_path__ + "static/media/Reset.708b0331.svg";